import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=75bdf901&scoped=true&"
import script from "./order-table.js?vue&type=script&lang=js&"
export * from "./order-table.js?vue&type=script&lang=js&"
import style0 from "./order-table.scss?vue&type=style&index=0&id=75bdf901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bdf901",
  null
  
)

export default component.exports